import { UserRegistryModel } from '@app/src/common/session/models';

export const hydrateDataForSend = (data: any, isInitLogin: boolean) => {
  const formatted = {
    name: `${data.name} ${data.surnames}`,
    email: data.email,
    password: data.password,
    login: isInitLogin,
    data: data.aditionalPurposes && 1
  };

  if (formatted.data !== 1) {
    delete formatted.data;
  }
  return formatted as UserRegistryModel
};